import {dimensionsKeys} from "../../../../utils";
import {CONSUMPTION_ITEMS, MEASURES} from "../../helpers";
import {EsgLabel} from "../../../../components/Forms";
import {Flex, GridItem, IconButton} from "@chakra-ui/react";
import {Fragment} from "react";
import {FaPen, FaTrash} from "react-icons/fa";
import {NUMBER_OF_ACTION_COLS, NUMBER_OF_STATIC_COLS} from "./DimensionsGrid";

function DimensionsGridItems({
                               items, handleEditItem, handleDeleteItem,
                               organizationStructure,
                               scope, consumptionTypesAttr, isPreview
                             }) {
  const getDimensionItemLabel = (dimKey, value) => {
    return organizationStructure.dimensions[dimKey]?.items?.find(el => el.id === value)?.name ?? "";
  };

  const getConsumptionTypeValue = (consumptionTypesAttr, id) => {
      const consumptionType = organizationStructure[consumptionTypesAttr]?.find(el => el.id === id) ?? "";
      return CONSUMPTION_ITEMS[consumptionType?.code] ?? consumptionType?.name ?? "";
  };

  const getMeasureValue = (consumptionTypeId, id) => {
      const measure = organizationStructure.measures.find(measure =>
          measure.consumptionTypeId === parseInt(consumptionTypeId))?.measures
          .find(measure => measure.id === parseInt(id));
      return MEASURES[measure?.code] ?? measure?.name ?? "";
  };

  const getElectricityMeasureValue = (electricityType, id) => {
      let measure = organizationStructure.electricityMeasures.find(measure =>
          measure.electricityType === electricityType)?.measures
          .find(measure => measure.id === parseInt(id));
      return MEASURES[measure?.code] ?? measure?.name ?? "";
  };

  return (
    <Fragment>
      {items && items.map(field => {
        const gridItems = [];

        dimensionsKeys.forEach(dimKey => {
          // Check if dimension is used for the current questionnaire
          if (organizationStructure.dimensions[dimKey]) {
            const dimensionValue = getDimensionItemLabel(dimKey, field[`${dimKey}Item`]);
            const dimensionItem = <EsgLabel overflow="hidden" text={dimensionValue} title={dimensionValue} />
            gridItems.push(dimensionItem);
          }
        });

        if(scope === "one") {
            // Adding consumption type grid item
            const consumptionTypeValue = getConsumptionTypeValue(consumptionTypesAttr, field.consumptionType);
            const consumptionTypeItem = <EsgLabel overflow="hidden" text={consumptionTypeValue} title={consumptionTypeValue} />
            gridItems.push(consumptionTypeItem);
        } else {
            const electricityTypeValue = CONSUMPTION_ITEMS[field.electricityType] ?? field.electricityType;
            const electricityTypeItem = <EsgLabel overflow="hidden" text={electricityTypeValue} title={electricityTypeValue} />
            gridItems.push(electricityTypeItem);
        }


        // Adding consumption value grid item
        const consumptionValue = field.consumptionValue ?? "";
        const consumptionValueItem = <EsgLabel overflow="hidden" text={consumptionValue} title={consumptionValue} />
        gridItems.push(consumptionValueItem);

          // Adding consumption measure grid item
        let consumptionMeasureValue;
        if(scope === "one")
            consumptionMeasureValue = getMeasureValue(field.consumptionType, field.consumptionMeasure);
        else consumptionMeasureValue = getElectricityMeasureValue(field.electricityType, field.consumptionMeasure);
        const consumptionMeasureItem = <EsgLabel overflow="hidden" text={consumptionMeasureValue} title={consumptionMeasureValue} />
        gridItems.push(consumptionMeasureItem);

        if (!isPreview) {
          // Adding row actions buttons in case if it's not in preview mode
          gridItems.push(<Flex>
            <IconButton
              type="button"
              icon={<FaPen size="16" />}
              width="100%"
              variant="ghost"
              color={"esg_green"}
              onClick={() => handleEditItem(field)}
            />
            <IconButton
              type="button"
              icon={<FaTrash size="16" />}
              width="100%"
              variant="ghost"
              color={"esg_red"}
              onClick={() => handleDeleteItem(field)}
            />
          </Flex>);
        }

        return gridItems.map((gridItem, gridItemIndex) => {
          // Total number of columns is sum of organization dimensions, static columns and action column
          const numberOfColumns = dimensionsKeys.filter(dimKey =>
            organizationStructure.dimensions[dimKey] !== null).length + NUMBER_OF_STATIC_COLS + (!isPreview ? NUMBER_OF_ACTION_COLS : 0);

          return <GridItem
            key={`${gridItemIndex}-${scope === "one" ? consumptionTypesAttr : "indirect"}`}
            borderWidth={"1px"}
            pl="4" pr="4" pt="2" pb="2"
            display="flex"
            alignItems="center"
            colSpan={isPreview ? 2 : gridItemIndex === numberOfColumns - 1 ? 1 : 2}
          >
            {gridItem}
          </GridItem>;
        });
      })}
    </Fragment>
  );
}

export default DimensionsGridItems;